
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import vSelect from './vselect'
import common from '@/tools/common'
export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
Datetime,
XDialog
},
methods: {
ToRule (types) {
try {
this.$router.push({name: 'FoodRulesSearchOfRule', query: {UserType: 'type10'}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
async Login () {
try {
const queryPromise = await this.$http.get('/API/FoodLoginUser/Login'
, {params: {company: this.department, username: this.username, password: this.password, phone: this.phone}})
this.queryResult = queryPromise.data

if (this.queryResult.success === true) {

common.setfoodSession(this.username)

this.$router.push({name: 'FoodRulesSearchLeaderPage', params: {UserType: 'type8'}})
return
} else {
this.$vux.alert.show({
title: '通知',
content: this.queryResult.outmsg})
return
}
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
}
},
data () {
return {
username: '',
password: '',
phone: '',
department: '',
queryResult: []
}
},
beforeCreate: function () {
},
async activated () {
}
}



// WEBPACK FOOTER //
// ./src/components/FoodRulesLoginPage.vue